import {ActivityIndicator, View} from 'react-native'

import {useProfileQuery} from '#/state/queries/profile'
import {useSession} from '#/state/session'
import * as Layout from '#/components/Layout'
import StudentDashboard from './components/StudentDashboard'
import TeacherDashboard from './components/TeacherDashboard'
import {AppProvider} from './contexts/AppContext'
import {BillsProvider} from './contexts/BillsContext'
import {StreakProvider} from './contexts/StreakContext'

function DashboardContent() {
  const {currentAccount} = useSession()
  const {data: profile, isLoading} = useProfileQuery({
    did: currentAccount?.did,
  })

  if (isLoading) {
    return (
      <View style={{flex: 1, alignItems: 'center', justifyContent: 'center'}}>
        <ActivityIndicator />
      </View>
    )
  }

  const p = profile as typeof profile & {accountType?: string}
  const isTeacher =
    p?.accountType === 'creator' || p?.accountType === 'organisation'

  return isTeacher ? <TeacherDashboard /> : <StudentDashboard />
}

export function DashboardScreen() {
  const {currentAccount} = useSession()
  const {data: profile} = useProfileQuery({did: currentAccount?.did})
  const p = profile as typeof profile & {accountType?: string}
  const role =
    p?.accountType === 'creator' || p?.accountType === 'organisation'
      ? ('teacher' as const)
      : ('student' as const)

  return (
    <AppProvider>
      <BillsProvider>
        <StreakProvider role={role}>
          <Layout.Screen>
            <Layout.Center style={{flex: 1}}>
              <DashboardContent />
            </Layout.Center>
          </Layout.Screen>
        </StreakProvider>
      </BillsProvider>
    </AppProvider>
  )
}
